export const col_primary = "#93278f";
export const col_secondary = "#7c4dff";
export const col_w = "#ffffff";
